type UserAccessInfoCardProps = {
  currentUserRole: { id: number; name: string } | null;
  roles: { id: number; name: string }[];
  handleDropdownChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  roleError?: string;
};
export const UserAccessInfoCard = ({
  currentUserRole,
  roles,
  handleDropdownChange,
  roleError,
}: UserAccessInfoCardProps) => {
  return (
    <div>
      <h3 className="mt-10 mb-5 label-light-blue-xl">
        権限 <span className="text-red-500">*</span>
      </h3>
      <div className="mb-2 text-xl text-black">
        <select
          className="dropdown-bar"
          value={currentUserRole?.id || ""}
          onChange={handleDropdownChange}
        >
          <option value="">未選択</option>
          {roles?.map((role) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </select>
        {roleError && <p className="text-red-500 mt-2">{roleError}</p>}
      </div>
    </div>
  );
};
